import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, ListItem } from '@mui/material';
import { checkBoxStyle } from '../Utils/Constants';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ReadOnlyDisplay = ({
    userData,
    allowNets
}) => {
    return (
        <>
            <Box sx={checkBoxStyle}>
                <Typography variant='body2' gutterBottom >Used quota: <em>{userData.mailbox_data.used_quota}</em></Typography>
                {userData.mailbox_data.password_reset_datetime && (
                    <Typography variant='body2' gutterBottom>Password reset date time: <em>{userData.mailbox_data.password_reset_datetime}</em></Typography>
                )}
            </Box>
            <Box sx={checkBoxStyle}>
                {/* Password expiry show */}
                {userData.mailbox_data.is_password_expired ? (
                    <Typography variant='body2' gutterBottom ><BlockIcon style={{ color: 'red', width: '1000px' }} />  User password expired.</Typography>
                ) : (
                    <Typography variant='body2' gutterBottom> <CheckCircleOutlineIcon style={{ color: 'green' }} /> User password not expired. </Typography>
                )}
                {userData.access_restrictions.allow_nets && (
                    <Typography variant='body2' gutterBottom>Access from allowed Ips: <em>{allowNets}</em></Typography>
                )}
                {userData.mailbox_data.created && (
                    <Typography variant='body2' gutterBottom>Created at: <em>{userData.mailbox_data.created}</em></Typography>
                )}
            </Box>
            <Box sx={checkBoxStyle}>
                {userData.mailbox_data.last_login_datetime && (
                    <Typography variant='body2' gutterBottom>Last login date time: <em>{userData.mailbox_data.last_login_datetime}</em></Typography>
                )}
                {userData.mailbox_data.last_login_ip_address && (
                    <Typography variant='body2' gutterBottom>Last login IP address: <em>{userData.mailbox_data.last_login_ip_address}</em></Typography>
                )}
            </Box>
            <Box sx={checkBoxStyle}>
                {userData.associated_group_ids?.length > 0 && (
                    <Accordion variant='outlined' size='sm'>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant='body2'>Associated Group IDs</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List size='small'>
                                {userData.associated_group_ids.map((item, index) => (
                                    <ListItem key={index}>{item}</ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                )}
            </Box>
        </>
    )
}

export default ReadOnlyDisplay;